import React from 'react';
import { Tooltip } from 'antd';
import styles from './column-title.module.sass';

export const ColumnTitle = ({ columnName, tooltipText }) => {
  return (
    <>
      <Tooltip placement="bottomRight" title={tooltipText}>
        <span className={styles.column_title}>{columnName}</span>
      </Tooltip>
    </>
  );
};
